// Тестовые HTML данные для проверки компонента без реального API
export const testArticleHTML = `<!DOCTYPE html>
<html lang="par_1C_language">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Process map</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            margin: 0;
            padding: 0;
            background-color: #f5f5f5;
        }
        .header {
            background-color: #fff;
            padding: 20px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            margin-bottom: 20px;
        }
        .header-content {
            max-width: 1200px;
            margin: 0 auto;
            text-align: center;
        }
        .header h1 {
            margin: 0 0 10px 0;
            color: #333;
            font-size: 24px;
        }
        .date-info {
            color: #666;
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 5px;
        }
        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
        }
        .description {
            background-color: #fff;
            padding: 20px;
            border-radius: 4px;
            margin-bottom: 20px;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }
        .process-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 30px;
            background-color: #fff;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
            border-radius: 4px;
            overflow: hidden;
        }
        .process-table th, .process-table td {
            border: 1px solid #e0e0e0;
            padding: 12px 15px;
            text-align: left;
            vertical-align: top;
        }
        .process-table th {
            background-color: #007577;
            font-weight: bold;
            color: #fff;
        }
        .main-process {
            font-weight: bold;
            background-color: #e8f4f4;
        }
        .sub-process {
            background-color: #fff;
        }
        .empty-row {
            height: 10px;
            background-color: #f5f5f5;
        }
        .print-button-container {
            text-align: center;
            margin-bottom: 20px;
        }
        .print-button {
            background-color: #007577;
            color: white;
            border: none;
            padding: 10px 20px;
            border-radius: 4px;
            cursor: pointer;
            font-size: 16px;
            transition: background-color 0.3s;
        }
        .print-button:hover {
            background-color: #3a6690;
        }
        @media print {
            .print-button {
                display: none;
            }
            body {
                background-color: white;
            }
            .header, .description {
                box-shadow: none;
            }
        }
    </style>
</head>
<body>
    <div class="header">
        <div class="header-content">
            <h1 id="processes"></h1>
            <div class="date-info">
		<p id="language"></p>
		<p>par_1C_language, par_1C_current_date</p>
	    </div>
        </div>
    </div>

    <div class="container">
        <div class="description">
            <p id="process_map_description"></p>
        </div>

        <!--div class="print-button-container">
            <button class="print-button" onclick="window.print()">Распечатать</button>
        </div-->

        <table class="process-table">
            <thead>
                <tr>
                    <th id="code"></th>
                    <th id="process"></th>
                    <th id="code"></th>
                    <th id="process"></th>
                </tr>
            </thead>
            <tbody>
                <tr class="main-process">
                    <td>11S</td>
                    <td id="11S"></td>
                    <td>11S.01</td>
                    <td id="11S.01"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>11S.02</td>
                    <td id="11S.02"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>11S.03</td>
                    <td id="11S.03"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>12S</td>
                    <td id="12S"></td>
                    <td>12S.01</td>
                    <td id="12S.01"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>12S.02</td>
                    <td id="12S.02"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>13S</td>
                    <td id="13S"></td>
                    <td>13S.01</td>
                    <td id="13S.01"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>13S.02</td>
                    <td id="13S.02"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>13S.03</td>
                    <td id="13S.03"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>13S.04</td>
                    <td id="13S.04"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>13S.05</td>
                    <td id="13S.05"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>14S</td>
                    <td id="14S"></td>
                    <td>14S.01</td>
                    <td id="14S.01"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>14S.02</td>
                    <td id="14S.02"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>14S.03</td>
                    <td id="14S.03"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>14S.04</td>
                    <td id="14S.04"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>14S.05</td>
                    <td id="14S.05"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>14S.06</td>
                    <td id="14S.06"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>14S.07</td>
                    <td id="14S.07"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>14S.08</td>
                    <td id="14S.08"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>15S</td>
                    <td id="15S"></td>
                    <td>15S.01</td>
                    <td id="15S.01"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>15S.02</td>
                    <td id="15S.02"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>20A</td>
                    <td id="20A"></td>
                    <td>20A.01</td>
                    <td id="20A.01"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>20A.02</td>
                    <td id="20A.02"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>20A.03</td>
                    <td id="20A.03"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>20A.04</td>
                    <td id="20A.04"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>20A.05</td>
                    <td id="20A.05"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>20A.06</td>
                    <td id="20A.06"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>20A.07</td>
                    <td id="20A.07"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>20A.08</td>
                    <td id="20A.08"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>24F</td>
                    <td id="24F"></td>
                    <td>24F.01</td>
                    <td id="24F.01"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>24F.02</td>
                    <td id="24F.02"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>24F.03</td>
                    <td id="24F.03"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>24F.04</td>
                    <td id="24F.04"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>24F.05</td>
                    <td id="24F.05"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>30C</td>
                    <td id="30C"></td>
                    <td></td>
                    <td></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>36I</td>
                    <td id="36I"></td>
                    <td>36I.01</td>
                    <td id="36I.01"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>42M</td>
                    <td id="42M"></td>
                    <td>42M.01</td>
                    <td id="42M.01"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>42M.02</td>
                    <td id="42M.02"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>42M.03</td>
                    <td id="42M.03"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>44P</td>
                    <td id="44P"></td>
                    <td>44P.01</td>
                    <td id="44P.01"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>50D</td>
                    <td id="50D"></td>
                    <td>50D.01</td>
                    <td id="50D.01"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>54B</td>
                    <td id="54B"></td>
                    <td>54B.01</td>
                    <td id="54B.01"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>54B.02</td>
                    <td id="54B.02"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>54B.03</td>
                    <td id="54B.03"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>54B.04</td>
                    <td id="54B.04"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>54B.05</td>
                    <td id="54B.05"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>54B.06</td>
                    <td id="54B.06"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>54B.07</td>
                    <td id="54B.07"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>54B.08</td>
                    <td id="54B.08"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>60N</td>
                    <td id="60N"></td>
                    <td>60N.01</td>
                    <td id="60N.01"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>60N.02</td>
                    <td id="60N.02"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>64R</td>
                    <td id="64R"></td>
                    <td>64R.01</td>
                    <td id="64R.01"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>70L</td>
                    <td id="70L"></td>
                    <td>70L.01</td>
                    <td id="70L.01"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>75U</td>
                    <td id="75U"></td>
                    <td>75U.01</td>
                    <td id="75U.01"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>75U.02</td>
                    <td id="75U.02"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>75U.03</td>
                    <td id="75U.03"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>75U.04</td>
                    <td id="75U.04"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>75U.05</td>
                    <td id="75U.05"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>80V</td>
                    <td id="80V"></td>
                    <td></td>
                    <td></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>82W</td>
                    <td id="82W"></td>
                    <td></td>
                    <td></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>85O</td>
                    <td id="85O"></td>
                    <td>85O.01</td>
                    <td id="85O.01"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>85O.02</td>
                    <td id="85O.02"></td>
                </tr>
                <tr class="sub-process">
                    <td></td>
                    <td></td>
                    <td>85O.03</td>
                    <td id="85O.03"></td>
                </tr>
                
                <tr class="empty-row">
                    <td colspan="4"></td>
                </tr>
                
                <tr class="main-process">
                    <td>90D</td>
                    <td id="90D"></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>

    <script>
        // Функция для печати
        function printPage() {
            window.print();
        }
    </script>
</body>
</html>
`;


















